import ResourceManager from "@/components/app/ResourceManager";
import { Badge } from "@/components/ui/badge";

const config = {
  endpoint: "partners",
  testid: "partners",
  singular: "Partner",
  overline: "Own Brand",
  title: "Own Brand Partners",
  subtitle: "White-label brand partners operating under Own Brand.",
  accent: "own_brand",
  documentsEntity: "partner",
  perms: { add: "partners.add", edit: "partners.edit", delete: "partners.delete" },
  columns: [
    { key: "partner_name", label: "Partner", render: (r) => <span className="font-medium text-zinc-900">{r.partner_name}</span> },
    { key: "partner_id", label: "Partner ID", badge: true },
    { key: "brand_name", label: "Brand" },
    { key: "domain", label: "Domain" },
    { key: "mobile", label: "Mobile" },
    { key: "active", label: "Status", render: (r) => (
      <Badge variant="outline" className={`rounded-sm font-normal ${r.active ? "border-emerald-500 text-emerald-600" : "border-zinc-300 text-zinc-400"}`}>{r.active ? "Active" : "Inactive"}</Badge>
    )},
  ],
  fields: [
    { name: "partner_name", label: "Partner Name", type: "text", required: true, section: "Basic" },
    { name: "company_name", label: "Company Name", type: "text", section: "Basic" },
    { name: "partner_type", label: "Partner Type", type: "text", section: "Basic" },
    { name: "mobile", label: "Mobile", type: "text", section: "Basic" },
    { name: "email", label: "Email", type: "email", section: "Basic" },
    { name: "pan", label: "PAN", type: "text", section: "Basic" },
    { name: "gstin", label: "GSTIN", type: "text", section: "Basic" },
    { name: "joining_date", label: "Joining Date", type: "date", section: "Basic" },
    { name: "address", label: "Address", type: "textarea", section: "Basic" },
    { name: "brand_name", label: "Brand Name", type: "text", section: "Brand" },
    { name: "brand_id", label: "Brand ID", type: "text", section: "Brand" },
    { name: "domain", label: "Domain", type: "text", section: "Brand" },
    { name: "website", label: "Website", type: "text", section: "Brand" },
    { name: "account_holder", label: "Account Holder", type: "text", section: "Banking" },
    { name: "bank_name", label: "Bank Name", type: "text", section: "Banking" },
    { name: "account_number", label: "Account Number", type: "text", section: "Banking" },
    { name: "ifsc", label: "IFSC", type: "text", section: "Banking" },
    { name: "upi_id", label: "UPI ID", type: "text", section: "Banking" },
    { name: "active", label: "Active", type: "switch", section: "Banking" },
  ],
};

export default function Partners() {
  return <ResourceManager config={config} />;
}
